interface AnalyticsEventProps {
  category?: string //enfoque del evento ej: en los errores pude ser el tipo de error
  action?: string // la acción que se realiza
  label?: string // elemento con el que interactúa
}
type EventName = 'view_error'

export const sendGtagEvent = (eventName: EventName | string, props?: AnalyticsEventProps) => {
  function gtag(_event: string, _eventName: any, _props?: object) {
    dataLayer.push(arguments)
  }
  gtag('event', eventName, props)
}
